<template>
  <footer
    class="w-full h-[9.125rem] px-8 pt-8 pb-10 | border-t border-grey-300 | flex gap-[.625rem] items-start"
  >
    <div class="flex gap-[.125rem] w-[13.9375rem] items-center">
      <img src="@/assets/images/icon/ico-genoplan-grey.svg" alt="" />
      <span class="font-bold text-20 text-grey-400">Genoplan MD</span>
    </div>
    <div class="text-grey-500 text-14">
      <p>
        사업자 등록번호 : 120-88-12093 | 통신판매업신고번호 : 2018-서울서초-2119
        | 대표이사 : 김성식 <br />
        소재지 : 경기도 성남시 분당구 판교로228번길 15 판교세븐벤처밸리1단지
        제3동 8층
      </p>
      <p class="mt-1">© Genoplan Korea Inc.</p>
    </div>
  </footer>
</template>
